export default "__VITE_ASSET__94837d3c__"